// extracted by mini-css-extract-plugin
export var gif = "_ls-0";